import { Pipe, PipeTransform } from '@angular/core';
import { TranslateLabelPipe, TranslateLabelPipeInput } from '@smooved/core';
import { Question } from '../interfaces/meta/question';

@Pipe({
    name: 'questionTitle',
})
export class QuestionTitlePipe implements PipeTransform {
    transform(value: Question, args: TranslateLabelPipeInput): string {
        const title = this.translateLabelPipe.transform(value.title, args);
        const subLabel = this.translateLabelPipe.transform(value.subLabel, args);
        return (title ? `<h6>${title}</h6>` : '') + (subLabel ? ` <span class="u-color-muted u-font-size-small">${subLabel}</span>` : '');
    }

    constructor(protected translateLabelPipe: TranslateLabelPipe) {}
}
